import { useAws } from "src/networking/aws/aws.hook";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetDraft,
  PostDraft,
  ServiceType,
} from "src/types";

export const usePostDraft = <
  T extends PostDraft["request"],
  D extends PostDraft["response"],
>() => {
  const hook = useAws<T, D>("postDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: "/bozza",
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetDraft = <
  T extends GetDraft["request"],
  D extends GetDraft["response"],
>() => {
  const hook = useAws<T, D>("getDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "get",
          path: `/bozza/${draftId}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
